// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Arsenal', 'Arsenal Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_4c12bd","variable":"__variable_4c12bd"};